exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[lazy=loading][data-v-693cfa03] {\n  height: 150px !important;\n  margin-top: 75px;\n}\n", ""]);

// exports
